import { Box, Link, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { stringUtils } from '@verifime/utils';
import { useState } from 'react';
import { ColoredIcon } from '../ColoredIconAndChip';
import { FilePreviewModal } from '../FileUploader/FilePreviewModal';
import { getMimeTypeFromFilename } from '../SandboxedFileViewer';

export default function DownloadLink({
  filename,
  url,
}: Readonly<{
  filename: string;
  url: string;
}>) {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const mimeType = getMimeTypeFromFilename(filename ?? url);

  return (
    <>
      <Link
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setIsPreviewOpen(true);
        }}
        sx={{ display: 'flex', gap: tokens.spacing2xs }}
      >
        <Typography>{stringUtils.ellipsis(filename || url, 'middle')}</Typography>
        <Box>
          <ColoredIcon iconName="openInNewRounded" />
        </Box>
      </Link>
      <FilePreviewModal
        open={isPreviewOpen}
        onClose={() => setIsPreviewOpen(false)}
        fileUrl={url}
        mimeType={mimeType ?? 'application/octet-stream'}
        enableZoom
      />
    </>
  );
}
